<ion-card [class.question-v2]="isV2()" [attr.id]="'checklist-question-' + question.id">
	@if (isV2()) {
		<div class="question-v2-top">
			<div class="question-v2-titles">
				<h3 class="question-v2-title">{{ question.translatedText }}</h3>
				@if (question.translatedDescription) {
					<div class="question-v2-description" [innerHtml]="question.translatedDescription"></div>
				}
			</div>
			@if (isAnswered()) {
				<span class="question-v2-status question-v2-status--answered">
					<span class="material-symbols-outlined" aria-hidden="true">check_circle</span>
					{{ "CHECKLIST_QUESTION__ANSWERED" | transloco }}
				</span>
			} @else {
				<span class="question-v2-status">{{ "CHECKLIST_QUESTION__REQUIRED" | transloco }}</span>
			}
		</div>
	} @else {
		<ion-card-header>
			<ion-card-title>
				{{ question.translatedText }}
			</ion-card-title>

			<ion-fab *ngIf="showMoreButton" vertical="top" horizontal="end">
				<ion-fab-button size="small">
					<ion-icon name="add-circle-outline"></ion-icon>
				</ion-fab-button>
				<ion-fab-list side="start">
					<ion-fab-button *ngIf="question.allowComments" (click)="activateComment()">
						<ion-icon name="chatbox-outline"></ion-icon>
					</ion-fab-button>
					<ion-fab-button *ngIf="question.allowImageAttachment" (click)="getImage()">
						<ion-icon name="camera-outline"></ion-icon>
					</ion-fab-button>
					<ion-fab-button *ngIf="question.allowCameraRoll" (click)="getFromGallery()">
						<ion-icon name="images-outline"></ion-icon>
					</ion-fab-button>
					<ion-fab-button (click)="createAssignment()">
						<ion-icon name="clipboard-outline"></ion-icon>
					</ion-fab-button>
				</ion-fab-list>
			</ion-fab>

			<ion-card-subtitle [innerHtml]="question.translatedDescription"></ion-card-subtitle>
		</ion-card-header>
	}

	<ion-card-content>
		<app-reference-images *ngIf="question.parent == null" [images]="question.images"></app-reference-images>
		<div class="question-answer">
			<ng-content></ng-content>
		</div>
		<div [formGroupName]="question.id" class="bottom-content">
			<app-comment formControlName="comment"></app-comment>
			<app-attachments formControlName="attachments" [v2]="isV2()" [hideHeadline]="isV2()"></app-attachments>
			<app-assignments [questionId]="question.id" formControlName="assignments"></app-assignments>
		</div>

		@if (isV2() && showMoreButton) {
			<div class="question-v2-quiet-actions">
				@if (question.allowComments) {
					<button type="button" class="question-v2-quiet-action" (click)="activateComment()">
						<span class="material-symbols-outlined" aria-hidden="true">chat_bubble</span>
						{{
							(hasComment() ? "CHECKLIST_QUESTION__EDIT_COMMENT" : "CHECKLIST_QUESTION__ADD_COMMENT")
								| transloco
						}}
					</button>
				}
				@if (question.allowImageAttachment) {
					<button type="button" class="question-v2-quiet-action" (click)="getImage()">
						<span class="material-symbols-outlined" aria-hidden="true">photo_camera</span>
						{{ "CHECKLIST_QUESTION__ADD_PHOTO" | transloco }}
					</button>
				}
				@if (question.allowCameraRoll) {
					<button type="button" class="question-v2-quiet-action" (click)="getFromGallery()">
						<span class="material-symbols-outlined" aria-hidden="true">image</span>
						{{ "CHECKLIST_QUESTION__ADD_GALLERY" | transloco }}
					</button>
				}
				<button type="button" class="question-v2-quiet-action" (click)="createAssignment()">
					<span class="material-symbols-outlined" aria-hidden="true">assignment</span>
					{{ "CHECKLIST_QUESTION__CREATE_ASSIGNMENT" | transloco }}
				</button>
			</div>
		}
	</ion-card-content>

	<ion-footer>
		<app-documentation [documentation]="question.documentation" [v2]="isV2()"></app-documentation>
	</ion-footer>
</ion-card>
